import { graphql } from "@/graphql/codegen"

graphql(`
  query GetInvoiceExpenseAccountOptions($input: GlAccountListInput!) {
    glAccount {
      list(input: $input) {
        __typename
        ... on GlAccountListSuccess {
          glAccounts {
            glAccountId
            number
            subNumber
            title
            type
            subType
            isActive
          }
          pageInfo {
            total
            limit
            offset
          }
        }
        ... on GlAccountFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
